import { createSlice, createSelector } from "@reduxjs/toolkit";
import { ofType } from "redux-observable";
import { of } from "rxjs";
import { switchMap, map, catchError, mergeMap } from "rxjs/operators";
import { authorizeBluemToken } from "@nxplatform/store-shared/authentication/shared-authentication-actions";
import { BLUEM_REGISTRATION_FEATURE_KEY } from "@nxplatform/store-shared/authentication/shared-authentication-feature-keys";
import { getCustomerTokenSuccess } from "@nxplatform/store-shared/customer/shared-customer-actions";
import { getSignInFailure } from "./authentication.slice.js";
const initialBluemRegistrationState = {
  titanToken: null,
  redirectUrl: null,
  startTopBluemRegistration: false
};
const bluemRegistrationSlice = createSlice({
  name: BLUEM_REGISTRATION_FEATURE_KEY,
  initialState: initialBluemRegistrationState,
  reducers: {
    generateTopBluemTokenStart: () => {
    },
    generateTopBluemTokenSuccess: (state, action) => {
      const { titanToken, redirectUrl } = action.payload || {};
      state.titanToken = titanToken;
      state.redirectUrl = redirectUrl;
      state.startTopBluemRegistration = false;
    },
    generateTopBluemTokenFailure: (state) => {
      state.startTopBluemRegistration = false;
    },
    triggerTopBluemRegistration: (state) => {
      state.startTopBluemRegistration = true;
    },
    authorizeViaBluemTokenStart: (state) => {
    },
    clearTopBluemToken: (state) => {
      state.titanToken = initialBluemRegistrationState.titanToken;
      state.redirectUrl = initialBluemRegistrationState.redirectUrl;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(authorizeBluemToken, (state, action) => {
    });
  }
});
const bluemRegistrationReducer = bluemRegistrationSlice.reducer;
const {
  generateTopBluemTokenStart,
  generateTopBluemTokenSuccess,
  generateTopBluemTokenFailure,
  triggerTopBluemRegistration,
  authorizeViaBluemTokenStart,
  clearTopBluemToken
} = bluemRegistrationSlice.actions;
const getBluemRegistrationState = (rootState) => rootState[BLUEM_REGISTRATION_FEATURE_KEY] || initialBluemRegistrationState;
const selectTopBluemTitanToken = createSelector(
  getBluemRegistrationState,
  ({ titanToken }) => titanToken
);
const selectTopBluemRedirectUrl = createSelector(
  getBluemRegistrationState,
  ({ redirectUrl }) => redirectUrl
);
const isTopBluemRegistrationStarted = createSelector(
  getBluemRegistrationState,
  ({ startTopBluemRegistration }) => startTopBluemRegistration
);
const fetchGeneratedBluemToken = (params) => ({
  type: generateTopBluemTokenStart.type,
  payload: params
});
const fetchGeneratedBluemTokenEpic = (action$, state$, { Api }) => action$.pipe(
  ofType(generateTopBluemTokenStart.type),
  switchMap((action) => Api.authentication.generateTopBluemToken(action.payload).pipe(
    map((data) => generateTopBluemTokenSuccess(data)),
    catchError(() => of(generateTopBluemTokenFailure()))
  ))
);
const authorizeViaBluemToken = (token) => ({
  type: authorizeViaBluemTokenStart.type,
  payload: token
});
const authorizeViaBluemTokenEpic = (action$, state$, { Api }) => action$.pipe(
  ofType(authorizeViaBluemTokenStart.type),
  switchMap((action) => Api.authentication.authorizeViaBluemToken(action.payload).pipe(
    mergeMap((data) => [
      getCustomerTokenSuccess(data),
      authorizeBluemToken(data)
    ]),
    catchError((err) => of(getSignInFailure(err.data || err.response)))
  ))
);
export {
  authorizeViaBluemToken,
  authorizeViaBluemTokenEpic,
  authorizeViaBluemTokenStart,
  bluemRegistrationReducer,
  bluemRegistrationSlice,
  clearTopBluemToken,
  fetchGeneratedBluemToken,
  fetchGeneratedBluemTokenEpic,
  generateTopBluemTokenFailure,
  generateTopBluemTokenStart,
  generateTopBluemTokenSuccess,
  getBluemRegistrationState,
  initialBluemRegistrationState,
  isTopBluemRegistrationStarted,
  selectTopBluemRedirectUrl,
  selectTopBluemTitanToken,
  triggerTopBluemRegistration
};
